import * as Yup from 'yup';

const validation = Yup.object({
    email: Yup.string().required("Email Required").email("Invalid email address"),
    password: Yup.string().required("Password Required").min(8, "Password must be at least 8 characters long."),
});

export default validation;
